import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  vehicles: [],
  vehicleData: {},
  currentVehicle: null,
  reminders: [],
  workOrders: [],
  documents: []
}

export const { actions, reducer } = createSlice({
  name: "vehicles",
  initialState,
  reducers: {
    setVehicles: (state, action) => {
      state.vehicles = action.payload
    },
    setVehicleData: (state, action) => {
      state.vehicleData = action.payload
    },
    setCurrentVehicle: (state, action) => {
      state.currentVehicle = action.payload
    },
    setReminders: (state, action) => {
      state.reminders = action.payload
    },
    setWorkOrders: (state, action) => {
      state.workOrders = action.payload
    },
    setDocuments: (state, action) => {
      state.documents = action.payload
    },
    resetVehicleData: (state) => {
      state.vehicles = []
      state.vehicleData = {}
      state.currentVehicle = null
      state.reminders = []
      state.workOrders = []
      state.documents = []
    }
  }
})

export default reducer
